import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

// img
import user from "../../../../Assets/images/user2.png";

// css
import styles from "../setting.module.scss";
import { AMDIN_UPDATE, GET_ADMIN_BY_ID } from "../../../../services/ApiCalls";
import { toast } from "react-toastify";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import fileUploader from "../../../../utilities/fileUploader";
import { createObjectURL } from "../../../../utilities/utilies";
import { useDispatch } from "react-redux";
import { profileImageChange } from "../../../../store/actions";
import AddressInput from "../../../../components/Common/address";

const requiredString = (name) =>
  z
    .string()
    .trim()
    .min(1, { message: `${name} is required` });

const schema = z.object({
  name: z.string().min(1, { message: "name is required" }),
  email: z
    .string()
    .min(1, { message: "Email is required" })
    .email("Invalid email address"),
  storeLocation: requiredString("Store Location"),
  city: requiredString("City"),
  state: requiredString("State / Province"),
  pincode: requiredString("Postal / ZIP Code"),
  country: requiredString("Country"),
  storeLocationCoordinates: z.any().optional(),
});

const getStoreLocation = (data) => data?.storeLocation || data?.address || "";

const getStoreLocationCoordinates = (data) => {
  if (data?.storeLocationCoordinates) {
    return data.storeLocationCoordinates;
  }

  const coordinates = data?.providerLocation?.coordinates;
  if (Array.isArray(coordinates) && coordinates.length >= 2) {
    return {
      lng: coordinates[0],
      lat: coordinates[1],
    };
  }

  return "";
};

const PersonalInformation = () => {
  const [adminData, setAdminData] = useState();
  const [image, setImage] = useState(null);
  const [uploadedImage, setUploadedImage] = useState();

  const dispatch = useDispatch();

  const [contactNumber, setContactNUmber] = useState({
    countryCode: "",
    mobileNumber: "",
  });
  const [Error, setError] = useState({
    contactNumber: "",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    trigger,
    watch,
  } = useForm({
    resolver: zodResolver(schema),
    values: {
      name: adminData?.name || "",
      email: adminData?.email || "",
      storeLocation: getStoreLocation(adminData),
      city: adminData?.city || "",
      state: adminData?.state || "",
      pincode: adminData?.pincode || "",
      country: adminData?.country || "",
      storeLocationCoordinates: getStoreLocationCoordinates(adminData),
    },
  });

  const getAdmin = async () => {
    try {
      const id = localStorage.getItem("_id");
      const res = await GET_ADMIN_BY_ID(id);
      if (res?.data?.status === "success") {
        setAdminData(res?.data?.data);
        setContactNUmber({
          countryCode: res?.data?.data?.countryCode || "",
          mobileNumber: res?.data?.data?.mobileNumber || "",
        });
        // setContactNUmber({
        //   countryCode: "+91",
        //   mobileNumber: "1234567890",
        // });
        setUploadedImage(res?.data?.data?.profileImage || "");
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  const onLatLongGet = useCallback((latLong) => {
    setValue("storeLocationCoordinates", latLong, { shouldValidate: true });
  }, [setValue]);

  const handleStoreLocationChange = useCallback((val) => {
    setValue("storeLocation", val, { shouldValidate: true });
  }, [setValue]);

  const triggerStoreLocation = useCallback(() => {
    trigger("storeLocation");
  }, [trigger]);

  const onSubmit = async (data) => {
    if (
      !contactNumber.countryCode.trim() ||
      !contactNumber.mobileNumber.trim()
    ) {
      return setError((p) => ({
        ...p,
        contactNumber: "Phone Number is Required",
      }));
    } else {
      setError((p) => ({ ...p, contactNumber: "" }));
    }

    try {
      let url;
      if (image) {
        url = await fileUploader(image);
        if (!url) {
          return;
        }
      }

      const adminId = localStorage.getItem("_id");
      const storeLocationCoordinates = data?.storeLocationCoordinates;

      const res = await AMDIN_UPDATE({
        userId: adminId,
        mobileNumber: contactNumber.mobileNumber,
        countryCode: contactNumber.countryCode,
        ...data,
        address: data.storeLocation,
        ...(storeLocationCoordinates?.lng != null &&
          storeLocationCoordinates?.lat != null && {
            providerLocation: {
              type: "Point",
              coordinates: [
                storeLocationCoordinates.lng,
                storeLocationCoordinates.lat,
              ],
            },
          }),
        ...(url && { profileImage: url }),
      });

      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        dispatch(profileImageChange(url));
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("something went wrong");
    }
  };

  useEffect(() => {
    getAdmin();
  }, []);

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className="justify-content-center">
          <Col lg="12" className="my-2">
            <div
              className={`${styles.uploadProfile} text-center position-relative`}
            >
              <div
                className={`${styles.profileImg} mx-auto imgWrp mb-3 rounded-circle`}
                style={{ background: "#F3F3F3" }}
              >
                <img
                  src={
                    (image && createObjectURL(image)) || uploadedImage || user
                  }
                  alt=""
                  className={`img-fluid h-100 w-100 rounded-circle object-fit-cover`}
                />
              </div>
              <label
                className="d-inline-flex align-items-center justify-content-center commonBtn h-auto  text-white px-2   py-1 rounded"
                type="button"
                htmlFor="image"
              >
                <input
                  type="file"
                  className="d-none"
                  id="image"
                  onChange={(e) =>
                    setImage((p) => {
                      return e.target.files[0];
                    })
                  }
                />
                Upload New
              </label>
            </div>
          </Col>
          <Col lg="12" className="my-2">
            <label
              htmlFor=""
              className={`${styles.formLabel} fw-sbold ps-2 ps-lg-3 mb-0 form-label`}
            >
              Name
            </label>
            <input
              type="text"
              placeholder="smith"
              className={`${styles.formControl} form-control`}
              {...register("name")}
            />

            {
              <p className="errorColor">
                {errors?.name && errors?.name?.message}
              </p>
            }
          </Col>
          <Col lg="12" className="my-2">
            <label
              htmlFor=""
              className={`${styles.formLabel} fw-sbold ps-2 ps-lg-3 mb-0 form-label`}
            >
              Mobile Number
            </label>
            <PhoneInput
              country={"us"}
              value={`${contactNumber.countryCode}Code, "+" + ${contactNumber.mobileNumber}`}
              onChange={(mobileNumber, { dialCode }) => {
                setContactNUmber((p) => ({
                  countryCode: dialCode,
                  mobileNumber: mobileNumber.replace(dialCode, ""),
                }));
              }}
            />
            {
              <p className="errorColor">
                {Error?.contactNumber && Error.contactNumber}
              </p>
            }
          </Col>
          <Col lg="12" className="my-2">
            <label
              htmlFor=""
              className={`${styles.formLabel} fw-sbold ps-2 ps-lg-3 mb-0 form-label`}
            >
              E-Mail ID
            </label>
            <input
              type="email"
              placeholder="smith"
              className={`${styles.formControl} form-control`}
              {...register("email")}
            />
            {
              <p className="errorColor">
                {errors?.email && errors?.email?.message}
              </p>
            }
          </Col>
          <Col lg="12" className="my-2">
            <label
              htmlFor=""
              className={`${styles.formLabel} fw-sbold ps-2 ps-lg-3 mb-0 form-label`}
            >
              Store Location <span className="asterisk">*</span>
            </label>
            <AddressInput
              name="storeLocation"
              placeholder="Store Location"
              errorLabel="Address"
              required
              defaultValue={getStoreLocation(adminData)}
              onLatLongGet={onLatLongGet}
              setValue={handleStoreLocationChange}
              trigger={triggerStoreLocation}
              value={watch("storeLocation")}
            />
            {
              <p className="errorColor">
                {(errors?.storeLocation && errors?.storeLocation?.message) ||
                  (errors?.storeLocationCoordinates &&
                    errors?.storeLocationCoordinates?.message)}
              </p>
            }
          </Col>
          <Col lg="6" className="my-2">
            <label
              htmlFor="city"
              className={`${styles.formLabel} fw-sbold ps-2 ps-lg-3 mb-0 form-label`}
            >
              City <span className="asterisk">*</span>
            </label>
            <input
              id="city"
              type="text"
              placeholder="Enter City"
              className={`${styles.formControl} form-control`}
              {...register("city")}
            />
            {
              <p className="errorColor">
                {errors?.city && errors?.city?.message}
              </p>
            }
          </Col>
          <Col lg="6" className="my-2">
            <label
              htmlFor="state"
              className={`${styles.formLabel} fw-sbold ps-2 ps-lg-3 mb-0 form-label`}
            >
              State / Province <span className="asterisk">*</span>
            </label>
            <input
              id="state"
              type="text"
              placeholder="Enter State / Province"
              className={`${styles.formControl} form-control`}
              {...register("state")}
            />
            {
              <p className="errorColor">
                {errors?.state && errors?.state?.message}
              </p>
            }
          </Col>
          <Col lg="6" className="my-2">
            <label
              htmlFor="pincode"
              className={`${styles.formLabel} fw-sbold ps-2 ps-lg-3 mb-0 form-label`}
            >
              Postal / ZIP code <span className="asterisk">*</span>
            </label>
            <input
              id="pincode"
              type="text"
              placeholder="Enter Postal / ZIP Code"
              className={`${styles.formControl} form-control`}
              {...register("pincode")}
            />
            {
              <p className="errorColor">
                {errors?.pincode && errors?.pincode?.message}
              </p>
            }
          </Col>
          <Col lg="6" className="my-2">
            <label
              htmlFor="country"
              className={`${styles.formLabel} fw-sbold ps-2 ps-lg-3 mb-0 form-label`}
            >
              Country <span className="asterisk">*</span>
            </label>
            <input
              id="country"
              type="text"
              placeholder="Enter Country"
              className={`${styles.formControl} form-control`}
              {...register("country")}
            />
            {
              <p className="errorColor">
                {errors?.country && errors?.country?.message}
              </p>
            }
          </Col>
          <Col lg="8" className="my-2 py-4">
            <Button
              className="d-flex align-items-center justify-content-center w-100 commonBtn"
              type="submit"
            >
              Save
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default PersonalInformation;
